<div class="redirect-page">
  <app-header></app-header>
  <div class="redirect-page__content">
    <pichincha-spot-module
      spot-title="Parece que aún no eres cliente Banco Pichincha"
      spot-description="Para crear una cuenta de Ahorro Flexible"></pichincha-spot-module>
    <pichincha-typography
      variant="prelo"
      weight="400"
      size="16px"
      line-height="24px"
      color="bp-grayScale500"
      >necesitas primero tener una Cuenta Transaccional.</pichincha-typography
    >
    <br />
    <pichincha-button
      *ngIf="!isCrm"
      label="Abrir cuenta"
      size="large"
      (click)="handleRedirect()"></pichincha-button>
  </div>
  <app-footer></app-footer>
</div>
